import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import request from '../ct-request';

const useRemoveAddress = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const dispatch = useDispatch();
  const { customerId } = useSelector((state) => ({
    customerId: state.accounts.user.id,
  }));

  const remove = useCallback(async (addressId, { onSuccess }) => {
    setIsLoading(true);

    try {
      await request({
        uri: `customers/addresses/${addressId}`,
        options: {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            customerId,
          },
        },
      });
      dispatch({ type: 'accounts/removeAddress', payload: addressId });
      setIsLoading(false);
      onSuccess();
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  }, [customerId, dispatch]);

  return {
    isLoading, error, remove,
  };
};

export default useRemoveAddress;
